module.exports = function(polls) {
	'use strict'
	polls.directive('allPollsDir',allPollsDir);
	allPollsDir.$inject=[];
	function allPollsDir() {
		return {
			template: require('./partial/allpolls.html'),
			controller:'allpollsController',
			controllerAs:'vmapl',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/pollsModule/allpolls/js/directive/allpollsDirective.js
// module id = 541
// module chunks = 0